export default "__VITE_ASSET__182d453d__"